var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"pa-0 ma-1",attrs:{"slot":"activator","small":"","icon":"","color":"warning"},slot:"activator"},[_c('v-icon',{attrs:{"small":""}},[_vm._v(_vm._s(_vm.icon || 'edit'))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }